module.exports = __webpack_public_path__ + "img/pentesting-icon.026107cf.svg";